import React from 'react';
import type { MeasurementStatusCounts } from '../services/measurementService';
import './StatsGrid.css';

interface StatsGridProps {
  statusCounts: MeasurementStatusCounts;
}

const StatsGrid: React.FC<StatsGridProps> = ({ statusCounts }) => {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-title">Upcoming</div>
        <div className="stat-value">{statusCounts.upcoming}</div>
      </div>
      <div className="stat-card">
        <div className="stat-title">Active</div>
        <div className="stat-value">{statusCounts.active}</div>
      </div>
      <div className="stat-card">
        <div className="stat-title">Reported</div>
        <div className="stat-value">{statusCounts.reported}</div>
      </div>
      <div className="stat-card">
        <div className="stat-title">Failed</div>
        <div className="stat-value">{statusCounts.failed}</div>
      </div>
    </div>
  );
};

export default StatsGrid;
